import React from 'react';

import { Settings } from 'src/features/administration//utils/types';
import { CURRENCY } from 'src/types';

const SettingsContext = React.createContext<Settings>({
    languages: [],
    default_language: 'en',
    default_currency: CURRENCY.EUR,
});

export default SettingsContext;
